const bodyScrollLock = require('body-scroll-lock');

module.exports = {
	methods: {
		$lockBodyScroll(element) {
			bodyScrollLock.disableBodyScroll(element);
		},
		$unlockBodyScroll(element) {
			bodyScrollLock.enableBodyScroll(element);
		},
	},
}